export function getSizeVideoByName(name: string): [number, number] {
  const match = name.match(/-(\d+)x(\d+)\.\w+$/);
  if (!match) {
    throw new Error(`Invalid video name format: ${name}`);
  }
  return [Number(match[1]), Number(match[2])];
}

export function formatNumberPdf(value: number): string {
  if (!value && value !== 0) {
    return "";
  }
  return value.toLocaleString("en-US").replace(/,/g, " ");
}

export function formatDatePDF(date: Date): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

export function isBlobPart(value: unknown): value is BlobPart {
  return !!value;
}
